import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/router/routes/index'
import Product from '@/router/routes/products'
import Technical from '@/router/routes/technical'
import Solution from '@/router/routes/solution'
import Intro from '@/router/routes/intros'
import ContactInfo from '@/router/routes/contact-info'

Vue.use(Router)

const router = new Router({
  routes: [
    Index,
    Product,
    Technical,
    Solution,
    Intro,
    ContactInfo
  ]
})

export default router
